import React from 'react'

const NotFound = () => {
    return (
        <div>
            <h4>Page Not Found</h4>
        </div>
    )
}
export default NotFound;